export const PASSWORD_ERROR_TYPES = Object.freeze({
  CHARS_LENGTH: "characters-length",
  INVALID_CHARS: "invalid-character",
})
